import { Component, OnInit } from '@angular/core';
import { Team } from '../team.model';
import { TeamService } from '../team.service';

@Component({
    selector: 'app-team-list',
    templateUrl: './team-list.component.html',
    styleUrls: ['./team-list.component.css']
})
export class TeamListComponent implements OnInit {
    public teams: Team[] = [];

    constructor(private teamService: TeamService) { }

    ngOnInit() {
        this.teamService.getTeamsCache()
            .then(result => this.teams = result)
            .catch(error => console.log(error));
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/teams/team-list/team-list.component.ts